import PropTypes from 'prop-types';

const flag = { activeFlag: PropTypes.string.isRequired };

const generalUserShape = {
  email: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  sso: PropTypes.string.isRequired,
};

export const userWithActiveFlagShape = {
  ...generalUserShape,
  ...flag,
};

export const UserWithoutActiveFlagPropTypes = PropTypes.shape(generalUserShape);

export const UserPropTypes = PropTypes.shape(userWithActiveFlagShape);
export const UsersPropTypes = PropTypes.arrayOf(UserPropTypes);
